const schema = {
  title: {
    type: 'text',
    label: 'Event Title',
    placeholder: 'Enter the question',
    required: true,
    info: true,
    character_count: 250,
    disabled: true
  },
  date: {
    type: 'date',
    label: 'Date',
    placeholder: 'Enter Date',
    required: true,
    info: true,
  },
  file_url: {
    type: 'text',
    label: 'File URL',
    placeholder: '',
    required: true,
    info: true,
  }
};

const minutes = [
  {
    id: "minutes07092021",
    active: true,
    date: "07 Sep 2020",
    title: "Board Meeting",
    link: "/",
  },
  {
    id: "minutes07092022",
    active: true, 
    date: "07 Sep 2020",
    title: "New Staff Member",
    link: "/",
  },
  {
    id: "minutes07092023",
    active: true,
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  },
  {
    id: "minutes07092024",
    active: true,
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  },
  {
    id: "minutes07092025",
    active: true,
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  },
  {
    id: "minutes07092026",
    active: true,
    date: "07 Sep 2020",
    title: "Dementia MDT Meeting",
    link: "/",
  }
]

export { schema, minutes };